import Backend from 'shared/lib/Backend';
import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default (id, coords, attrs) => async (dispatch, getState) => {
  const body = new FormData();
  console.log(coords)
  body.append('coords', coords);

  const url = `${window.location.pathname}/upload_map_by_coords`;
  const response = await Backend.post(url, { body });
  if(response.result === 'success') {
    const data = { src: response.src, ...attrs };
    dispatch({ type: "SECTIONS/UPDATE", payload: { id, data } });
    debouncedSaveTemplate(dispatch, getState);
  } else if(response.result === 'fail') {
    dispatch({ type: "FAIL", payload: response.messages[0] });
  }
};
